import { createPlugin } from "../createPlugin";

/**
 * Example analytics stub — demonstrates plugin registration without app coupling.
 */
export function createAnalyticsStubPlugin(options) {
  options = options || {};
  var sink = options.sink || function () {};

  return createPlugin({
    name: "analytics-stub",
    version: "0.1.0",
    onReady: function (ctx) {
      sink({ type: "player_ready", state: ctx.getState() });
    },
    onEvent: function (eventName, payload) {
      if (eventName === "ended" || eventName === "error" || eventName === "recovered") {
        sink({ type: eventName, payload: payload });
      }
    },
  });
}

export default createAnalyticsStubPlugin;
